import { __exports as a } from "./contact-channels230.js";
var e;
function D() {
  return e ? a : (e = 1, function(i) {
    Object.defineProperty(i, "__esModule", { value: !0 }), i.Doctype = i.CDATA = i.Tag = i.Style = i.Script = i.Comment = i.Directive = i.Text = i.Root = i.isTag = i.ElementType = void 0;
    var t;
    (function(c) {
      c.Root = "root", c.Text = "text", c.Directive = "directive", c.Comment = "comment", c.Script = "script", c.Style = "style", c.Tag = "tag", c.CDATA = "cdata", c.Doctype = "doctype";
    })(t = i.ElementType || (i.ElementType = {}));
    function n(c) {
      return c.type === t.Tag || c.type === t.Script || c.type === t.Style;
    }
    i.isTag = n, i.Root = t.Root, i.Text = t.Text, i.Directive = t.Directive, i.Comment = t.Comment, i.Script = t.Script, i.Style = t.Style, i.Tag = t.Tag, i.CDATA = t.CDATA, i.Doctype = t.Doctype;
  }(a), a);
}
export {
  D as __require
};
//# sourceMappingURL=contact-channels212.js.map
